import styled, { css } from "styled-components";

export const Container = styled.div`
  position: relative;
  width: 100%;
  min-height: 228px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 24px;

  border-radius: 7.601px;
  border: 0.95px solid var(--Stroke, rgba(241, 243, 247, 0.80));
  background: #fff;

  box-shadow: 0px 0px 19px -3px rgba(13, 13, 13, 0.09);

  @media(max-width: 1024px) {
    max-width: 288px;
    margin-left: auto;
    margin-right: auto;
  }

  @media(max-width: 767px) {
    max-width: 100%;
    min-height: 174px;
    margin: 10px 70px 20px 70px;
  }
`;
export const Image = styled.div`
  overflow: hidden;

  img {
    width: 36px;
  }
`;

export const Content = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 16px;

  ${({ hasTooltip }) => hasTooltip && css`
    cursor: pointer;
  `}
`

export const Title = styled.h2`
  color: #393939;
  font-family: "Platform Web";
  font-size: 16.081px;
  font-style: normal;
  font-weight: 500;
  line-height: 25px;
`;

export const ToolTipContainer = styled.div`
  position: absolute;
  width: 100%;

  @media(max-width: 767px) {
    top: -96px;
  }
`

export const Description = styled.p`
  width: 100%;
  position: relative;
  padding-right: 10px;

  opacity: 0.7;
  color: #393939;
  font-family: "Work Sans";
  font-size: 12.865px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;

  span {
    position: relative;
    font-weight: 700;

		cursor: pointer;
		text-decoration: underline;

		img {
			position: relative;
			top: 3px;
		}
	}

`;

export const ContainerFooter = styled.div`
  flex: 1;
  display: flex;
  align-items: flex-end;
`

export const LinkFooter = styled.a`
  opacity: 0.7;
  color: #393939;
  font-family: "Work Sans";
  font-size: 12.865px;
  font-style: normal;
  font-weight: 700;
  line-height: 142.8%;
  text-decoration-line: underline;
`
